import React from "react";
import IntegratedExternalAgentApp from "../../components/IntegratedExternalAgentApp";

export default function IntegratedFinanceApp() {
  return <IntegratedExternalAgentApp agent="finance" title="AzentMart AI Finance Agent" />;
}
